import * as rota from 'routes/paths';

// MENSAGENS

/* INPUT */
export const MSG_CAMPO_OBRIGATORIO_GERAL = `Existem campos obrigatórios que não foram preenchidos`;
export const MSG_CAMPO_OBRIGATORIO = `O campo é obrigatório`;
export const MSG_CAMPO_INVALIDO = 'O campo é inválido';
export const MSG_TAMANHO_CAMPO = 'Limite máximo de caracteres atingido';
export const MSG_TAMANHO_MIN_JUSTIFICATIVA = 'Justificativa deve conter no mínimo 15 caracteres';

/* ARQUIVOS */
export const MSG_NENHUM_ARQUIVO_ENCONTRADO = 'Nenhum arquivo encontrado';
export const MSG_FORMATO_NAO_PERMITIDO_PDF = 'Formato de arquivo não permitido, informe um arquivo no formato PDF';
export const MSG_TAMANHO_NOME_ARQUIVO = 'O nome do arquivo ultrapassou o tamanho permitido (142)';
export const MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO = 'O tamanho do arquivo máximo deve ser de 10MB';
export const MSG_TOOLTIP_TAMANHO_ARQUIVO = `O tamanho máximo dos arquivos devem ser de até 10MB`;
export const MSG_TOOLTIP_ADICIONAR_ARQUIVO = `Adicionar novo arquivo`;
export const MSG_TOOLTIP_BAIXAR_TODOS_ARQUIVOS = `Baixar todos os arquivos`;

/* GENÉRICAS ERROS */
export const MSG_SESSAO_EXPIRADA = 'Sessão expirada';
export const MSG_ERRO_PADRAO = 'Um problema inesperado ocorreu, tente novamente.';
export const MSG_ERRO_PERMISSAO = 'Você não tem permissão para realizar essa ação';
export const MSG_ERRO_COMUNICACAO = 'Falha na comunicação entre dois ou mais servidores';
export const MSG_ERRO_CEP = 'Cep não localizado';
export const ALERTA_REPETICAO = 'Alerta de Repetição';
export const REQUERIMENTO_DUPLICADO = (tempo = '') =>
  `Já existe um requerimento aberto para esse serviço às ${tempo}. Deseja continuar?`;

/* GENÉRICAS */
export const MSG_CANCELAR_OPERACAO = 'Deseja cancelar a operação?';
export const MSG_TOOLTIP_APAGAR = `Apagar itens selecionados`;
export const MSG_HISTORICO_NAO_ENCONTRADO = `Nenhum histórico encontrado`;
export const MSG_INICIAR_ATENDIMENTO = 'Atendimento iniciado com sucesso!';
export const MSG_SALVAR_FORMULARIO_SUCESSO = (email = '') =>
  `Formulário enviado com sucesso! O protocolo da solicitação foi encaminhado no email ${email}`;
export const MSG_VERIFICAR_SPAN = 'Verifique também o lixo eletrônico ou a caixa de span';

/* SUCESSO SALVAR */
export const MSG_SALVAR_ATENDENTE_SUCESSO = `Cadastro de atendente realizado com sucesso!`;
export const MSG_SALVAR_SERVICO_SUCESSO = `Cadastro do serviço realizado com sucesso!`;
export const MSG_SALVAR_SETOR_SUCESSO = `Cadastro do setor realizado com sucesso!`;
export const MSG_SALVAR_DADOS_CADASTRAIS_SUCESSO = `Dados cadastrais salvos com sucesso!`;

/* SUCESSO EDITAR */
export const MSG_FORMULARIO_EDITADO = 'Formulário alterado com sucesso!';
export const MSG_FORMULARIO_DEVOLVIDO = 'Formulário devolvido ao contribuinte com sucesso!';
export const MSG_FORMULARIO_ENCAMINHADO = 'Formulário encaminhado com sucesso!';
export const MSG_ATENDENTE_EDITADO_SECESSO = 'Usuário alterado com sucesso!';
export const MSG_DADOS_CADASTRAIS_EDITADO = 'Dados cadastrais alterados com sucesso!';

/* SUCESSO DELETAR */
export const MSG_SETOR_DELETADO_SUCESSO = 'Setor deletado com sucesso!';
export const MSG_ATENDENTE_DELETADO_SUCESSO = 'Usuário deletado(a) com sucesso!';
export const MSG_POSTO_ATENDIMENTO_DELETADO_SUCESSO = 'Posto de atendimento deletado com sucesso!';

/* VALIDAÇÃO DE DOCUMENTO */
export const MSG_CPF_INCORRETO = 'O CPF está incorreto!';
export const MSG_CPF_INVALIDO = 'O CPF não é valido!';
export const MSG_CNPJ_INCORRETO = 'O CNPJ está incorreto!';
export const MSG_CNPJ_INVALIDO = 'O CNPJ não é valido!';

/* VALIDAÇÃO CAMPOS */
export const MSG_INPUT_SELECIONE_PERIODO = 'Selecione um período.';
export const MSG_INPUT_SELECIONE_SETOR = 'Selecione um setor.';
export const MSG_INPUT_SELECIONE_UM_ATENDENTE = 'Selecione ao menos um atendente.';
export const MSG_INPUT_SELECIONE_SERVICO = 'Selecione o serviço.';
export const MSG_INPUT_MAX_SERVICO = 'Selecione no máximo 6 serviços';
export const MSG_INPUT_MAX_ATENDENTES = 'Selecione no máximo 6 atendentes';

/* TOOLTIP */
export const MSG_TOOLTIP_SALVAR_TEXTO =
  'Salvar Texto: Salva o texto escrito no campo Justificativa, essa ação é visível para todos.';
export const MSG_TOOLTIP_SALVAR_DEVOLVER =
  'Salvar e Devolver: Salva o texto escrito no campo Justificativa e devolve o requerimento ao Contribuinte, essa ação é visível para todos.';
export const MSG_TOOLTIP_FINALIZAR =
  'Finalizar Atendimento: Salva o texto escrito no campo Justificativa e finaliza o atendimento do requerimento, essa ação é visível para todos.';
export const MSG_TOOLTIP_ENCAMINHAR = 'Encaminhar Atendimento: Exibe novas opções para encaminhar o requerimento.';
export const MSG_TOOLTIP_ADICIONAR_ANALISE =
  'Alterar para Em Análise: Salva o texto escrito no campo Justificativa e altera o requerimento para Em análise, essa ação é visível para todos.';
export const MSG_TOOLTIP_ADICIONAR_ATENDIMENTO =
  'Alterar para Em Atendimento: Salva o texto escrito no campo Justificativa e remove o requerimento da Análise, retornando para Atendimento, essa ação é visível para todos.';
export const MSG_TOOLTIP_CANCELAR =
  'Cancelar Requerimento: Salva o texto escrito no campo Justificativa e cancela o requerimento, essa ação é visível para todos.';
export const MSG_TOOLTIP_ATENDENTE_ANTERIOR =
  'Encaminhar para atendente Anterior: Salva o texto escrito no campo Justificativa e devolve o requerimento para o atendente anterior prosseguir com o atendimento, essa ação é visível para todos.';

// TIPOS ALERTA
export const ALERTA = {
  SUCESSO: 'success',
  INFO: 'info',
  AVISO: 'warning',
  ERRO: 'error',
};

// TIPOS FORMULÁRIOS
export const FORMULARIOS = {
  DUVIDAS: { tituloIdentificacao: 'DUVIDA', id: 1, rota: rota.duvidas },
  SERVICOS: { tituloIdentificacao: 'SERVICOS', id: 2, rota: rota.servicos },
};

//TIPO_DOCUMENTO
export const TIPO_DOCUMENTO = {
  CPF: 1,
  CNPJ: 2,
};

//TIPO_PESSOA
export const ENUM_TIPO_PESSOA = {
  fisica: { id: 1, descricao: 'Pessoa Física' },
  juridica: { id: 2, descricao: 'Pessoa Jurídica' },
};

export const ENUM_CONDICAO_STATUS = {
  SOLICITADO: { id: 1, label: 'Solicitado' },
  RECUSADO: { id: 2, label: 'Recusado' },
  APROVADO: { id: 3, label: 'Aprovado' },
};

export const TODOS_CONDICOES_STATUS = [
  { id: ENUM_CONDICAO_STATUS.SOLICITADO.id, label: ENUM_CONDICAO_STATUS.SOLICITADO.label },
  { id: ENUM_CONDICAO_STATUS.RECUSADO.id, label: ENUM_CONDICAO_STATUS.RECUSADO.label },
  { id: ENUM_CONDICAO_STATUS.APROVADO.id, label: ENUM_CONDICAO_STATUS.APROVADO.label },
];

export const STATUS_REQUERIMENTO = {
  ABERTO: {
    id: 1,
    identificador: 'ABERTO',
    descricao: 'Aberto',
    cor: '#ffe58f',
    borderColor: '#ffc53d',
    colorName: 'gold',
  },
  ENCAMINHADO_ATENDENTE: {
    id: 2,
    identificador: 'ENCAMINHADO',
    descricao: 'Encaminhado Atendimento',
    cor: '#d3adf7',
    borderColor: '#722ed1',
    colorName: 'purple',
  },
  EM_ATENDIMENTO: {
    id: 3,
    identificador: 'EMATENDIMENTO',
    descricao: 'Em Atendimento',
    cor: '#91d5ff',
    borderColor: '#1890ff',
    colorName: 'blue',
  },
  FINALIZADO_DEFERIDO: {
    id: 4,
    identificador: 'FIMDEFERIDO',
    descricao: 'Finalizado Deferido',
    cor: '#b7eb8f',
    borderColor: '#52c41a',
    colorName: 'green',
  },
  DEVOLVIDO_CONTRIBUINTE: {
    id: 5,
    identificador: 'DCONTRIBUINTE',
    descricao: 'Devolvido ao Contribuinte',
    cor: '#ffadd2',
    borderColor: '#eb2f96',
    colorName: 'magenta',
  },
  EM_ANALISE: {
    id: 6,
    identificador: 'EMANALISE',
    descricao: 'Em Análise',
    cor: '#ffd591',
    borderColor: '#fa8c16',
    colorName: 'orange',
  },
  REATENDIMENTO: {
    id: 7,
    identificador: 'REATENDIMENTO',
    descricao: 'Reatendimento',
    cor: '#adc6ff',
    borderColor: '#2f54eb',
    colorName: 'geekblue',
  },
  CANCELADO: {
    id: 8,
    identificador: 'CANCELADO',
    descricao: 'Cancelado',
    cor: '#ffa39e',
    borderColor: '#f5222d',
    colorName: 'red',
  },
  FINALIZADO_INDEFERIDO: {
    id: 9,
    identificador: 'FIMINDEFERIDO',
    descricao: 'Finalizado Indeferido',
    cor: '#7cb305',
    borderColor: '#5BB361',
    colorName: 'green_FinalizadoIndeferido',
  },
  FINALIZADO_PROCESSO_GERADO: {
    id: 10,
    identificador: 'FIMPROCESSO',
    descricao: 'Finalizado - Processo Gerado',
    cor: '#1EE822',
    borderColor: '#62E66D',
    colorName: 'green_finalizadoProcessoGerado',
  },
  DIRECIONADO_OUTRO_ATENDENTE: {
    id: 11,
    identificador: 'DIRECIONADO',
    descricao: 'Direcionado a outro Atendente',
    cor: '#AB94E3',
    borderColor: '#8C77E4',
    colorName: 'purple_dark',
  },
  SOLICITACAO_ATENDIDA: {
    id: 12,
    identificador: 'SOLICITACAOATENDIDA',
    descricao: 'Solicitação Atendida',
    cor: '#61d911',
    borderColor: '#0BE607',
    colorName: 'green_solicitacaoAtendida',
  },
};

//TODOS OS MODAIS
export const ENUM_MODAL = {
  HISTORICO: 'Histórico da Requisição',
  HISTORICO_RELATORIO_REQUERIMENTO: 'Histórico do Requerimento',
  CARREGAR_DADOS_CPF: 'Carregar dados recentes',

  LISTA_REATENDIMENTO: 'Novos Requerimentos em Reatendimento',
  LISTA_ATENDENTE_PENDENTE: 'Novos Usuários pendentes',

  JUSTIFICATIVA: {
    CONTRIBUINTE: 'Justificativa Contribuinte',
    USUARIO_FRENTE: 'Justificativa',
    USUARIO_SETORIAL: 'Justificativa Setorial',
  },

  ENCAMINHAR: {
    ATENDENTE: 'Encaminhar Requerimento Atendente',
    SUPERVISOR: 'Encaminhar Requerimento Supervisor',
    SUPERVISOR_SETORIAL: 'Encaminhar Requerimento Supervisor Setorial',
  },

  ENCAMINHAR_REQUERIMENTO_ATENDENTE: 'Encaminhar Requerimento Atendente',
  ENCAMINHAR_REQUERIMENTO_ATENDENTE_SETORIAL: 'Encaminhar Requerimento Atendente Setorial',
  ENCAMINHAR_REQUERIMENTO_SUPERVISOR: 'Encaminhar Requerimento Supervisor',
  ENCAMINHAR_REQUERIMENTO_SUPERVISOR_SETORIAL: 'Encaminhar Requerimento Supervisor Setorial',

  RESUMO_REQUERIMENTO: 'Resumo Finalizar Requerimento',

  SUCESSO_REQUERIMENTO: 'Requerimento Salvo',
  PERFIL_DIVERGENTE: 'Perfil Divergente',
  CADASTRO_PENDENTE: 'Cadastro Pendente',
  RESOLVE_CAPTCHA: 'Resolver Captcha',
  PERFIL_SEM_CADASTRO_NO_FAS: 'Perfil sem cadastro no FAS',
};

export const ENUM_STATUS_ATIVO = {
  ATIVO: { value: 1, label: 'Ativo' },
  INATIVO: { value: 2, label: 'Inativo' },
};

export const ENUM_STATUS_IS_SETORIAL = {
  SIM: { id: true, value: 'SIM', label: 'Sim' },
  NAO: { id: false, value: 'NAO', label: 'Não' },
};

export const ENUM_CARGO = {
  ATENDENTE: 1,
  SUPERVISOR: 2,
  SUPERVISOR_SETORIAL: 3,
};

export const TAG_JUSTIFICATIVA = {
  TITULO_ATENDENTE: 'Atendente: ',
  TITULO_CONTRIBUINTE: 'Contribuinte: ',
};

export const ENUM_TIPO_RELATORIO = {
  STATUS: 1,
  SOLICITACOES: 2,
  ATENDIMENTOS: 3,
  SETOR: 4,
  TIPO: 5,
};

export const ENUM_TIPO_LAYOUT_RELATORIO_DOWNLOAD = {
  PAISAGEM: 'Paisagem',
  RETRATO: 'Retrato',
};

// TIPOS ALERTA
export const ID_RELATORIO = {
  ABERTO: 'ABERTO',
  FECHADO: 'FIM',
  PENDENTE: 'PENDENTE',
  PERFORMANCE_INICIADOS: 'iniciados',
  PERFORMANCE_FECHADO: 'fechados',
  PERFORMANCE_PENDENTES: 'pendentes',
  PERFORMANCE_ENCAMINHADO: 'encaminhado',
  PERFORMANCE_DEVOLVIDO: 'devolvido',
};

export const ENUM_COLOR_LIGHT = {
  primaryColorSefaz: '#0078bb',
  backgroundColorSefaz: '#F1F6FF',
  backgroundSecondSefaz: '#FFFFFF',
  bottomColorSefaz: '#FFFFFF',
  textoColor: '#2c2929',
  textoContrasteColor: '#ffffff',
  cinzaColor: '#A9A8AB',
};

export const ENUM_COLOR_DARK = {
  primaryColorSefaz: '#0078bb',
  backgroundColorSefaz: '#383838',
  backgroundSecondSefaz: '#272727',
  bottomColorSefaz: '#3b3b3b',
  textoColor: '#FFFFFF',
  textoContrasteColor: '#070707',
  cinzaColor: '#cbc8cf',
};

export const ENUM_COLOR_CONTRAST = {
  primaryColorSefaz: '#FFFFFF',
  backgroundColorSefaz: '#000000',
  backgroundSecondSefaz: '#000000',
  bottomColorSefaz: '#000000',
  textoColor: '#FFFFFF',
  textoContrasteColor: '#353535',
  cinzaColor: '#353535',
};

export const ENUM_THEME = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  CONTRAST: 'CONTRAST',
  CUSTOM: 'CUSTOM',
};

// STORAGE
export const ID_REQUERIMENTO_DETALHAR = 'ID_REQUERIMENTO_DETALHAR';
export const ID_SERVICO_DETALHAR = 'ID_SERVICO_DETALHAR';
export const ID_POSTOS_ATENDIMENTO_DETALHAR = 'ID_POSTOS_ATENDIMENTO_DETALHAR';
export const IS_TROCA_PERFIL = 'IS_TROCA_PERFIL';
export const IS_NEW_LOGIN = 'IS_NEW_LOGIN';
export const ID_CAPTCHA = 'ID_CAPTCHA';
export const USER_ENTERED_CAPTCHA_CODE = 'USER_ENTERED_CAPTCHA_CODE';
export const LOCALIZADOR = 'localizador';
export const DOCUMENTO = 'documento';
export const USUARIO_LOGADO_FAS = 'USUARIO_LOGADO_FAS';
export const STORAGE_THEME_FAS = 'STORAGE_THEME_FAS';
export const STORAGE_THEME_CUSTOM_FAS = 'STORAGE_THEME_CUSTOM_FAS';
export const SISTEMAS_E_SEFAZ_USUARIO = 'SISTEMAS_E_SEFAZ_USUARIO';
